import { useQuery } from "@tanstack/react-query";
import { EmployeeService } from "../services/department-viags/employee-viags.service";
import { useUser } from "./use-user";
import { useMemo } from "react";

export const useCheckGroupUser = () => {
  const { email } = useUser();
  const isQLTLGroup = email?.startsWith("QLTL_Gr");

  const { data, isLoading } = useQuery({
    queryKey: ["viags-employee"],
    queryFn: () => EmployeeService.checkGroupUser(email),
  });

  const isGroupUser = useMemo(() => isQLTLGroup || data, [data, isQLTLGroup]);

  return { data, isQLTLGroup, isGroupUser, isLoading };
};
